import {HookClass, Hook, BaseHook, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import xlsx from 'xlsx';
import {Observable, of} from 'rxjs';
import {ArtfactKind} from '@mrp-brasil/nick-data-commons';

@HookClass('sheet')
export class SheetHook extends BaseHook {

    @Hook('b35a4aad-42de-487c-886d-d0b93becbb48')
    public getSheet(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const workbook = xlsx.readFile(input.object.file);

        const output = new NickProcessArtfact();
        output.kind = ArtfactKind.ANY;
        output.object = workbook;
        return of(output);
    }


    @Hook('2a745b49-a35b-49af-9d54-c45eee84c80b')
    public getBufferSheetToJSON(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const workbook = xlsx.read(input.object.buffer);

        const output = new NickProcessArtfact();
        output.kind = ArtfactKind.ANY;
        output.object = {sheetNames: workbook.SheetNames, sheets: {}};

        workbook.SheetNames.forEach((sheetName: string) => {
            const data = xlsx.utils.sheet_to_json(workbook.Sheets[sheetName]);
            output.object.sheets[sheetName] = {
                columns: data.length ? Object.keys(data[0]) : [],
                data
            };
        });

        return of(output);
    }

    @Hook('02c925cd-0d39-4fd3-a668-04fba5a281a6')
    public getSheetToJSON(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const workbook = xlsx.readFile(input.object.file);

        const output = new NickProcessArtfact();
        output.kind = ArtfactKind.ANY;
        output.object = {sheetNames: workbook.SheetNames, sheets: {}};

        workbook.SheetNames.forEach((sheetName: string) => {
            const data = xlsx.utils.sheet_to_json(workbook.Sheets[sheetName]);
            output.object.sheets[sheetName] = {
                columns: data.length ? Object.keys(data[0]) : [],
                data
            };
        });

        return of(output);
    }

    @Hook('253fed6b-87ec-4ac0-8601-0e6b50bd2280')
    public JSONtoSheet(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const columns = input.object.config.columnsNames;
        const _headers: any[] = [];

        const ws = xlsx.utils.aoa_to_sheet([columns]);

        const enums: any = {};

        if (input.object.config.enums) {
            Object.keys(input.object.config.enums).forEach((key: any) => {
                const enumMap = new Map<any, any>();
                input.object.config.enums[key].forEach((item: any) => {
                    enumMap.set(item.key, item.value);
                });

                enums[key] = enumMap;
            });
        }

        let data = input.object.data;

        if (!input.object.config.skipAttributes) {
            data = input.object.data.map((item: any) => {
                const value: any = {};
                input.object.config.columnsAttributes.forEach((attr: string) => {
                    let ops: any[] = [];
                    if (attr.split('|').length > 1) {
                        ops = attr.split('|');
                        attr = ops.shift();
                    }

                    _headers.push(attr);

                    if (attr.indexOf('.') >= 0)
                        value[attr] = attr.split('.').reduce((o, i) => (o ? o[i] : o), item);
                    else
                        value[attr] = item[attr];

                    ops.forEach((op: string) => {
                        if (op.startsWith('enum:')) {
                            const enumId = op.replace('enum:', '');
                            value[attr] = enums[enumId]
                                ? (enums[enumId].has(value[attr]) ? enums[enumId].get(value[attr]) : value[attr])
                                : value[attr];
                        } else if (op.startsWith('money:')) {
                            value[attr] = (value[attr]?.toFixed ? value[attr]?.toFixed(2).toString().replace('.', ',') : value[attr]);
                        }
                    });

                });
                return value;
            });
        }

        xlsx.utils.sheet_add_json(ws, data, {
            header: _headers,
            skipHeader: true,
            origin: 1
        });

        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, ws, input.object.config.title);

        const buffer = xlsx.write(wb, {type: 'buffer', bookType: 'xlsx'});

        const uploadArtifact = new NickProcessArtfact();
        uploadArtifact.kind = ArtfactKind.ANY;
        uploadArtifact.object = {
            buffer,
            contentType: 'application/excel'
        };

        return of(uploadArtifact);
    }

}
